var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1191_1352",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 41
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.183594,
    width: 40,
    height: 40,
    fill: "#F5F5F5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1191_1352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5366 13.762L21.8266 5.95197C20.7266 5.21197 19.2866 5.21197 18.1766 5.95197L6.46658 13.762C5.54658 14.372 4.99658 15.402 4.99658 16.512V31.972C4.99658 33.652 6.59658 34.972 8.64658 34.972H31.3566C33.3966 34.972 35.0066 33.652 35.0066 31.972V16.512C35.0066 15.412 34.4666 14.372 33.5366 13.762ZM22.3066 32.662H17.6866V25.522C17.6866 25.002 18.1066 24.592 18.6166 24.592H21.3666C21.8866 24.592 22.2966 25.012 22.2966 25.522V32.662H22.3066ZM32.6866 31.972C32.6866 32.252 32.1566 32.662 31.3466 32.662H24.6066V25.522C24.6066 23.732 23.1566 22.282 21.3666 22.282H18.6166C16.8266 22.282 15.3766 23.732 15.3766 25.522V32.662H8.63658C7.82658 32.662 7.29658 32.242 7.29658 31.972V16.512C7.29658 16.182 7.45658 15.882 7.73658 15.702L19.4466 7.87197C19.7766 7.65197 20.2066 7.65197 20.5266 7.87197L32.2466 15.692C32.5166 15.872 32.6766 16.182 32.6766 16.512V31.972H32.6866Z",
    fill: "#7D7D7D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeOff);
export default __webpack_public_path__ + "static/media/home_off.33aa5f920ef874e9073c1fad4cf5e0fa.svg";
export { ForwardRef as ReactComponent };